/* eslint-disable no-template-curly-in-string */
import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  invalidValue: {
    id: 'Invalid Value',
    defaultMessage: 'Invalid Value',
  },
})
